import { render } from "./BasketIcon.vue?vue&type=template&id=39e4dd9c&ts=true"
import script from "./BasketIcon.vue?vue&type=script&lang=ts"
export * from "./BasketIcon.vue?vue&type=script&lang=ts"

import "./BasketIcon.vue?vue&type=style&index=0&id=39e4dd9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__